import React from "react";
import { Box, Typography } from "@mui/material";
import {
  calculateOrderDiscountSummary,
  formatILS,
} from "../../helpers/orderDiscountHelper";

export default function OrderPriceWithDiscount({
  order,
  showTitle = false,
  onlyFinal = false,
}) {
  const summary =
    calculateOrderDiscountSummary(order);

  const shippingCost =
    Number(order?.shippingCost || 0);

  const finalTotalWithShipping =
    Number(summary.finalTotal || 0) +
    shippingCost;

  // אם רוצים להציג רק מחיר סופי
  if (onlyFinal) {
    return (
      <Typography
        sx={{
          fontSize: "1.2rem",
          fontWeight: "bold",
        }}
      >
        {formatILS(finalTotalWithShipping)}
      </Typography>
    );
  }

  // אם אין הנחה
  if (
    !summary.isEligible ||
    summary.discountAmount <= 0
  ) {
    return (
      <Box>
        {showTitle && (
          <Typography
            sx={{
              fontWeight: "bold",
              mb: 1,
            }}
          >
            סיכום מחיר
          </Typography>
        )}

        <Typography>
          מחיר מוצרים:{" "}
          {formatILS(summary.subtotal)}
        </Typography>

        <Typography>
          מחיר משלוח:{" "}
          {formatILS(shippingCost)}
        </Typography>

        <Typography
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            mt: 1,
          }}
        >
          סה"כ לתשלום:{" "}
          {formatILS(finalTotalWithShipping)}
        </Typography>
      </Box>
    );
  }

  // אם יש הנחה
  return (
    <Box>
      {showTitle && (
        <Typography
          sx={{
            fontWeight: "bold",
            mb: 1,
          }}
        >
          סיכום מחיר
        </Typography>
      )}

      <Typography>
        מחיר מוצרים:{" "}
        {formatILS(summary.subtotal)}
      </Typography>

      <Typography sx={{ color: "gray" }}>
        הנחת לקוח {summary.discountPercent}%:{" "}
        {formatILS(summary.discountAmount)}
      </Typography>

      <Typography>
        מחיר משלוח:{" "}
        {formatILS(shippingCost)}
      </Typography>

      <Typography
        sx={{
          fontSize: "1.2rem",
          fontWeight: "bold",
          mt: 1,
        }}
      >
        סה"כ לתשלום:{" "}
        {formatILS(finalTotalWithShipping)}
      </Typography>
    </Box>
  );
}